import type { FC } from "react";
import { Ban, Check, Loader2 } from "lucide-react";

interface ToolStatusIconProps {
  status?: { type: string; reason?: string };
}

export const ToolStatusIcon: FC<ToolStatusIconProps> = ({ status }) => {
  if (status?.type === "running") {
    return <Loader2 className="size-3.5 text-purple-600 animate-spin" />;
  }
  if (status?.type === "incomplete" && status.reason === "cancelled") {
    return <Ban className="size-3.5 text-purple-600" />;
  }
  return <Check className="size-3.5 text-purple-600" />;
};
